import { GetWbCompanies } from "../services/financialService";
const requestCompaniesType = "REQUEST_COMPANIES";
const receiveCompaniesType = "RECEIVE_COMPANIES";
const initialState = { companies: [], loading: false };

export const actionCreators = {
  requestCompanies: () => async (dispatch, getState) => {
    let { companies } = getState().companies;
    if (companies && companies.length > 0) {
      return;
    }
    dispatch({ type: requestCompaniesType });

    companies = await GetWbCompanies();

    dispatch({ type: receiveCompaniesType, companies });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestCompaniesType) {
    return {
      ...state,
      loading: true
    };
  }

  if (action.type === receiveCompaniesType) {
    const { companies } = action;
    return {
      ...state,
      companies,
      loading: false
    };
  }

  return state;
};
